import {
  UPLOAD_REQUEST, UPLOAD_SUCCESS, UPLOAD_FAILURE, UPLOAD_PROGRESS,
  CLEAR
} from '../../actions/ingestion/upload';

const initialState = {
  // Upload state
  isUploading: false,
  uploadError: null,
  uploadResult: null,
  progress: 0,
  
  // File info
  selectedFile: null,
  columnTypes: null
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    // Upload file
    case UPLOAD_REQUEST:
      return {
        ...state,
        isUploading: true,
        uploadError: null,
        uploadResult: null,
        progress: 0,
        selectedFile: action.payload.file,
        columnTypes: action.payload.columnTypes
      };
    
    case UPLOAD_SUCCESS: {
      const status = action.payload?.status || action.payload?.execution?.status;
      const isTerminal = ['completed', 'failed', 'cancelled'].includes(status);
      const progressFromPayload =
        action.payload?.progress?.percentage ??
        action.payload?.execution?.progress?.percentage;

      return {
        ...state,
        isUploading: !isTerminal,
        uploadResult: action.payload,
        uploadError: null,
        progress: progressFromPayload ?? (isTerminal ? 100 : state.progress)
      };
    }
    
    case UPLOAD_FAILURE:
      return {
        ...state,
        isUploading: false,
        uploadError: action.payload,
        progress: 0
      };
    
    case UPLOAD_PROGRESS:
      return {
        ...state,
        progress: action.payload
      };
    
    // Clear state
    case CLEAR:
      return initialState;
    
    default:
      return state;
  }
};
